<template>
  <div class="egl-elm egl-detail setting clearfix">
    <el-form-item :label="$locale('global.cinemaName')" prop="name" :rules="formRules.name">
      <el-input :placeholder="$locale('theatre.plsEnterMovieName')" v-model="detailObj.name" :disabled="!editable" maxlength="255"></el-input>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.olduuid')" v-if="detailObj.id == ''" prop="oldCinemaUuid">
      <el-input :placeholder="$locale('setting.cinema.p.olduuid')" v-model="detailObj.oldCinemaUuid" :disabled="!editable" maxlength="255"></el-input>
    </el-form-item>
    <el-row :gutter="40">
      <el-col :span="8">
        <el-form-item :label="$locale('setting.brand.postalcode')" prop="postalCode" :rules="formRules.postalCode">
          <el-input :placeholder="$locale('setting.brand.p.postalcode')" v-model="detailObj.postalCode" :disabled="!editable" maxlength="10"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="$locale('setting.emergency.area')" prop="region" :rules="formRules.region">
          <el-select
            :placeholder="$locale('setting.brand.p.area')"
            v-model="detailObj.region"
            :disabled="!editable"
            @change="setPrefecture"
          >
            <el-option
              v-for="item in regionData"
              :label="item.value"
              :value="item.key"
              :key="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="$locale('setting.emergency.perfecture')" prop="prefecture" :rules="formRules.prefecture">
          <el-select
            :placeholder="$locale('setting.brand.p.perfecture')"
            v-model="detailObj.prefecture"
            :disabled="!editable"
          >
            <el-option
              v-for="item in prefectureOptions"
              :label="item.value"
              :value="item.key"
              :key="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="$locale('setting.cinema.city')" prop="city" :rules="formRules.city">
          <el-input :placeholder="$locale('setting.brand.p.city')" v-model="detailObj.city" :disabled="!editable" maxlength="255"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item :label="$locale('global.streetAddress')+'1'+$locale('setting.brand.example.address1')" prop="address1" :rules="formRules.address1">
      <el-input :placeholder="$locale('setting.brand.p.address1')" v-model="detailObj.address1" :disabled="!editable" maxlength="255"></el-input>
    </el-form-item>
    <el-form-item :label="$locale('global.streetAddress')+'2'+$locale('setting.brand.example.address2')" prop="address2">
      <el-input :placeholder="$locale('setting.brand.p.address2')" v-model="detailObj.address2" :disabled="!editable" maxlength="255"></el-input>
    </el-form-item>
    <el-form-item :label="$locale('setting.brand.tel')" prop="phone">
      <el-input :placeholder="$locale('setting.brand.p.fax')" v-model="detailObj.phone" :disabled="!editable" maxlength="20"></el-input>
    </el-form-item>
    <el-form-item :label="$locale('setting.brand.fax')" prop="faxNumber">
      <el-input :placeholder="$locale('setting.brand.p.fax')" v-model="detailObj.faxNumber" :disabled="!editable" maxlength="20"></el-input>
    </el-form-item>
    <el-form-item :label="$locale('global.email')" prop="email">
      <el-input :placeholder="$locale('setting.brand.p.email')" v-model="detailObj.email" :disabled="!editable" maxlength="100"></el-input>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.owner')" prop="managerName">
      <el-input :placeholder="$locale('setting.cinema.p.owner')" v-model="detailObj.managerName" :disabled="!editable" maxlength="255"></el-input>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.owernstamp')" prop="controllerUrl">
      <UploadContainer
        :imageList="[detailObj.controllerUrl]"
        @onSuccess="({response}) => uploadSuccess(response, 'controllerUrl')"
        @onDelete="deletePhoto('controllerUrl')"
      ></UploadContainer>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.businesshours')" prop="businessHours">
      <el-input :placeholder="$locale('setting.cinema.p.businesshours')" v-model="detailObj.businessHours" :disabled="!editable" maxlength="255"></el-input>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.twitter')" prop="twitterUrl">
      <el-input :placeholder="$locale('setting.cinema.p.twitter')" v-model="detailObj.twitterUrl" :disabled="!editable" maxlength="255"></el-input>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.instagram')" prop="instagramUrl">
      <el-input :placeholder="$locale('setting.cinema.p.instagram')" v-model="detailObj.instagramUrl" :disabled="!editable" maxlength="255"></el-input>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.facebook')" prop="facebookUrl">
      <el-input :placeholder="$locale('setting.cinema.p.facebook')" v-model="detailObj.facebookUrl" :disabled="!editable" maxlength="255"></el-input>
    </el-form-item>
    <el-form-item :label="$locale('setting.brand.croplogo') + '（130 X 50）'" prop="logo">
      <UploadContainer
        :imageList="[detailObj.logo]"
        @onSuccess="({response}) => uploadSuccess(response, 'logo')"
        @onDelete="deletePhoto('logo')"
      ></UploadContainer>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.copywrite')" prop="copyright">
      <el-input :placeholder="$locale('setting.cinema.p.copywrite')" v-model="detailObj.copyright" :disabled="!editable" maxlength="255"></el-input>
    </el-form-item>
    <el-form-item :label="$locale('global.image')" prop="photosUrl">
      <UploadContainer
        type="D"
        :imageList="detailObj.photosUrl"
        :limit="10"
        @onSuccess="uploadSuccess2"
        @onDelete="idx => deletePhoto('photosUrl', idx)"
        @upload="uploadFile"
      ></UploadContainer>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.standByImage')" prop="standByImage">
      <UploadContainer
        :imageList="[detailObj.standByImage]"
        @onSuccess="({response}) => uploadSuccess(response, 'standByImage')"
        @onDelete="deletePhoto('standByImage')"
      ></UploadContainer>
    </el-form-item>
    <el-form-item label="concession" prop="concessionMenuPdf">
      <UploadContainer
          type="C"
          :imageList="[detailObj.concessionMenuPdf]"
          :uploadBtnText="$locale('global.uploadPDF')"
          action="/api/cinema/uploadPdf"
          :accept="'.pdf'"
          @onSuccess="({response}) => uploadSuccess(response, 'concessionMenuPdf')"
        ></UploadContainer>
        <el-button
          class="egl-btn-red"
          @click="deletePhoto('concessionMenuPdf')"
          v-if="detailObj.concessionMenuPdf"
        >
      {{ $locale("global.delete") }}
    </el-button>
        <el-button class="egl-btn-yellow" v-if="detailObj.concessionMenuPdf" @click="downloadPDF('concessionMenuPdf')">ダウンロード</el-button>
    </el-form-item>
    <el-form-item label="commercial" prop="commercialMenuPdf">
      <UploadContainer
          type="C"
          :imageList="[detailObj.commercialMenuPdf]"
          :uploadBtnText="$locale('global.uploadPDF')"
          action="/api/cinema/uploadPdf"
          :accept="'.pdf'"
          @onSuccess="({response}) => uploadSuccess(response, 'commercialMenuPdf')"
        ></UploadContainer>
        <el-button
          class="egl-btn-red"
          @click="deletePhoto('commercialMenuPdf')"
          v-if="detailObj.commercialMenuPdf"
        >
      {{ $locale("global.delete") }}
    </el-button>
        <el-button class="egl-btn-yellow" v-if="detailObj.commercialMenuPdf" @click="downloadPDF('commercialMenuPdf')">ダウンロード</el-button>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.intro')" prop="intro">
      <!-- <el-input :placeholder="$locale('setting.cinema.p.intro')" v-model="detailObj.intro" :disabled="!editable" type="textarea" maxlength="255"></el-input> -->
      <editor v-model="detailObj.intro" />
    </el-form-item>
  </div>
</template>

<script>
import UploadContainer from "@/components/common/UploadContainer";
import Editor from "@/components/common/Tinymce/Rich";

export default {
  name: "cinemaBasicSetting",
  props: {
    regionData: Array,
    detailObj: Object,
  },
  components: {
    UploadContainer,
    Editor,
  },
  data() {
    return {
      editable: true,
      action: "create",
      formRules: {
        name: [ {
          required: true,
          // message: this.$locale("theatre.plsEnterTheatreName"),
          message: this.$locale("theatre.plsEnterMovieName"),
          trigger: "blur",
        } ],
        postalCode: [ {
          required: true,
          message: this.$locale("setting.cinema.plsEnterPostalCode"),
          trigger: "blur",
        } ],
        region: [ {
          required: true,
          message: this.$locale("setting.cinema.plsEnterRegion"),
          trigger: "change",
        } ],
        prefecture: [ {
          required: true,
          message: this.$locale("setting.cinema.plsEnterPrefecture"),
          trigger: "change",
        } ],
        city: [ {
          required: true,
          message: this.$locale("setting.cinema.plsEnterCity"),
          trigger: "blur",
        } ],
        address1: [ {
          required: true,
          message: this.$locale("setting.cinema.plsEnterAddress1"),
          trigger: "blur",
        } ],
      },
    };
  },
  computed: {
    prefectureOptions() {
      const targetObj = this.regionData.find(region => region.key.toLowerCase() === this.detailObj.region.toLowerCase()) || {};
      const result = targetObj.prefectures;
      return result;
    }
  },
  methods: {
    uploadFile(file) {
      console.log(file);
    },
    deletePhoto(key, idx) {
      if (key === "photosUrl" && idx > -1) {
        let newPhoto_arr = [ ...this.detailObj.photosUrl ];
        newPhoto_arr.splice(idx, 1);
        this.detailObj.photosUrl = newPhoto_arr;
      } else {
        this.detailObj[key] = "";
      }
    },
    uploadSuccess(res, key) {
      if (res.success) {
        if (key === "photosUrl") {
          this.detailObj.photosUrl = [
            ...this.detailObj.photosUrl,
            res.data,
          ];
        } else {
          this.detailObj[key] = res.data;
        }
      }
    },
    downloadPDF(key) {
      window.open(this.detailObj[key]);
    },
    uploadSuccess2(res) {
      if (res.success) {
        this.detailObj.photosUrl = [
          ...this.detailObj.photosUrl,
          res.data
        ];
      }
    },
    setPrefecture() {
      this.detailObj.prefecture = "";
    },
  },
};
</script>
